import { render, staticRenderFns } from "./build_image_task_detail.vue?vue&type=template&id=ef31ee1e&scoped=true&"
import script from "./build_image_task_detail.vue?vue&type=script&lang=ts&"
export * from "./build_image_task_detail.vue?vue&type=script&lang=ts&"
import style0 from "./build_image_task_detail.vue?vue&type=style&index=0&id=ef31ee1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef31ee1e",
  null
  
)

export default component.exports